
import { sendRequest } from './index';
import { API_ABTEST_URL } from '@core/constants/API';

export const AB_Test = () => {
    return sendRequest({
        url: `${API_ABTEST_URL}`,
        method: 'GET'
    });
};